/**
 * Schema of Sistema
 * @author Simpli CLI generator
 */
import {InputType, Schema} from 'simpli-web-sdk'
import {bool} from 'simpli-web-sdk'
import Sistema from '@/model/resource/Sistema'

export default (model: Sistema): Schema => ({
  idSistemaPk: {
    content: model.idSistemaPk,
    editable: false,
  },

  nome: {
    content: model.nome,
    input: InputType.TEXT,
    meta: {
      required: true,
      maxlength: '255',
    },
  },

  ativo: {
    content: bool(model.ativo),
    hidden: true,
    editable: false,
  },
})
